module.exports = __webpack_public_path__ + "img/card.7f0917f9.png";